import React from 'react';

import FieldReportListScreen, { FieldReportListConfig } from 'src/screen/Protected/FieldReportListScreen/FieldReportListScreen';
import { COMMISSIONING_TYPES } from 'src/screen/Protected/FieldReportListScreen/fieldReportTypes';

const CONFIG: FieldReportListConfig = {
  category: 'commissioning',
  types: COMMISSIONING_TYPES,
  titleKey: 'nav.commissioning',
  createDialogTitleKey: 'commissioning.selectType',
  showStatus: true,
  tableId: 'commissioning-table',
  rootId: 'commissioning-screen',
  columnWidths: {
    withSelect: ['5%', '18%', '22%', '14%', '18%', '14%', '4%'],
    withoutSelect: ['20%', '25%', '15%', '20%', '20%'],
  },
};

export default function CommissioningScreen () {
  return <FieldReportListScreen config={CONFIG} />;
}
